import { setFatalSink } from '../app/globalHandlers';
import { log } from '../app/logger';

/**
 * Bridges the OBS-1 global handlers to the screen.
 *
 * At a venue there is no console. An uncaught error that only reaches `console.error` is an error
 * Andrew cannot see, and a harness that silently stops measuring while appearing to work is worse
 * than one that crashes. NFR-8: surfaced, not swallowed.
 */
export function setFatalSinkBridge(setError: ((message: string) => void) | null): void {
  setFatalSink(setError);
}

export { log };
